if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // 「カートへの追加上限」関連の既定文言を分かりやすい文言に差し替える。
              const description = response.description;
              // (A) 一部のみ追加: 「出品状況により、アイテムN点のみが…」(N=上限点数を抽出)
              const clampMatch =
                typeof description === 'string' && description.match(/(\d+)\s*点のみがカートに追加されました/);
              // (B) 既に上限がカートにある: 「このアイテムの最大数がすでに…」(数値はメッセージに無い)
              const maxInCart =
                typeof description === 'string' && description.includes('最大数がすでにカートに入っています');
              const transformed = Boolean(clampMatch) || maxInCart;

              // 表示(handleErrorMessage)と購読側(publish)に必ず同一の文言を渡す。
              const finalize = (text) => {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: transformed && typeof response.errors === 'string' ? text : response.errors || text,
                  message: response.message,
                });
                this.handleErrorMessage(text);
              };

              // finalize 完了(max-in-cart は cart.js 取得を含む)まで submit フローが待てる
              // よう promise 化し、後段の refreshPromise と合わせて return する。
              let messagePromise = Promise.resolve();
              if (clampMatch) {
                const limit = clampMatch[1];
                finalize(`一度に購入できるのは最大${limit}点です。${limit}点のみがカートに追加されました。`);
              } else if (maxInCart) {
                // 上限数はメッセージに含まれないため、カートの現在数量(=上限)を取得して補強する。
                // 同一 variant がギフト宛先等の line-item properties で複数行に分かれることが
                // あるため、variant_id 一致の全行を合算する。取得失敗時は数値なしの文言。
                const variantId = formData.get('id');
                messagePromise = fetch(`${window.routes.cart_url}.js`)
                  .then((res) => res.json())
                  .then((cart) => {
                    const totalQty = (cart.items || [])
                      .filter((it) => String(it.variant_id || it.id) === String(variantId))
                      .reduce((sum, it) => sum + (it.quantity || 0), 0);
                    finalize(
                      totalQty > 0
                        ? `一度に購入できる最大数は${totalQty}点です。すでに最大数がカートに入っています。`
                        : 'すでに最大数がカートに入っています。'
                    );
                  })
                  .catch(() => finalize('すでに最大数がカートに入っています。'));
              } else {
                finalize(description);
              }

              // 「カートへの追加上限」(出品状況による clamp)等、エラー応答でも実際には
              // カートに一部追加されるケースがある。その場合でもカート個数/ドロワー内容が
              // 更新されるよう、最新のカート断面を取得して該当要素を直接差し替える。
              // ※ renderContents は使わない(drawer を毎エラーで開いてしまう/通知は key 必須で
              //   例外になるため)。ここでは drawer を開かずセクション要素のみ最新化する。
              // finally(loading 解除)が更新完了まで待つよう promise を return する。
              let refreshPromise = Promise.resolve();
              const errorSections =
                this.cart && typeof this.cart.getSectionsToRender === 'function'
                  ? this.cart.getSectionsToRender()
                  : [];
              if (errorSections.length > 0) {
                const sectionIds = errorSections.map((section) => section.id).join(',');
                refreshPromise = fetch(`${window.location.pathname}?sections=${sectionIds}`)
                  .then((res) => res.json())
                  .then((sections) => {
                    const parser = new DOMParser();
                    errorSections.forEach((section) => {
                      const el = section.selector
                        ? document.querySelector(section.selector)
                        : document.getElementById(section.id);
                      const html = sections[section.id];
                      if (!el || !html) return;
                      const parsed = parser.parseFromString(html, 'text/html');
                      // selector 指定なし(例: cart-icon-bubble)は id 優先で取得し、
                      // 対象要素そのものが innerHTML に入って入れ子になるのを防ぐ。
                      const fragment = section.selector
                        ? parsed.querySelector(section.selector)
                        : parsed.getElementById(section.id) || parsed.querySelector('.shopify-section');
                      if (fragment) el.innerHTML = fragment.innerHTML;
                    });
                    // #CartDrawer を差し替えると constructor で付けた overlay の close リスナーが
                    // 失われるため、renderContents と同様に再付与する。
                    if (this.cart.tagName === 'CART-DRAWER' && typeof this.cart.close === 'function') {
                      const overlay = this.cart.querySelector('#CartDrawer-Overlay');
                      if (overlay) overlay.addEventListener('click', this.cart.close.bind(this.cart));
                    }
                  })
                  .catch((e) => console.error(e));
              }

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return Promise.all([refreshPromise, messagePromise]);
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return Promise.all([refreshPromise, messagePromise]);
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
